<div id="st-expired-points-sidebar-container" class="sidebar-container">
  <!-- Sidebar Header -->
  <header class="sidebar-header">
    <div id="st-expired-points-header-content" class="header-content">
      <h2>{{ 'expired_points' | translate }}</h2>
    </div>
    <button class="close-btn" (click)="panelClose.emit()" (keydown.enter)="panelClose.emit()" (keydown.space)="$event.preventDefault(); panelClose.emit()" tabindex="0">✖</button>
  </header>
  <div id="st-expired-points-sidebar-content" class="sidebar-content">
    <div id="st-expired-points-event-points-container" class="event-points-container">
      <div id="st-expired-points-event-name" class="event-name">
        <h3>{{ 'event_name' | translate }}</h3>
      </div>
      <div id="st-expired-points-points" class="points">
        <h3>{{ 'points' | translate }}</h3>
      </div>
    </div>
    @if (isLoading) {
    <stupa-skeleton-loader id="st-expired-points-loader-container" class="p-3" [rows]="5" [columns]="3" />
    }
    <div id="st-expired-points-event-points-data" *ngIf="!isLoading && errorMessage" class="event-points-data">
      <p>{{ errorMessage }}</p>
    </div>
    <div id="st-expired-points-event-points-data-1" *ngIf="!isLoading && !errorMessage && expiredEvents.length === 0" class="event-points-data">
      <p>{{ 'no_expired_points_available' | translate }}</p>
    </div>
    <div [id]="'st-expired-points-event-points-data-2' + (event)"
      *ngFor="let event of expiredEvents; trackBy: trackById"
      class="event-points-data"
    >
      <div id="st-expired-points-data-row" class="data-row">
        <div id="st-expired-points-event-data" class="event-data">
          <div id="st-expired-points-event-title" class="event-title">{{ event.event_name }}</div>
          <div id="st-expired-points-event-dates" class="event-dates">
            <span class="date-item">{{ 'expiry' | translate }}: {{ event.expiry_date }}</span>
            <span class="date-item">{{ 'allocation' | translate }}: {{ event.allocation_date }}</span>
          </div>
        </div>
        <div id="st-expired-points-points-data" class="points-data">
          <span class="points-value">{{ event.points_expired }}</span>
        </div>
      </div>
    </div>
  </div>
  <div id="st-expired-points-sidebar-footer" class="sidebar-footer">
    <button class="go-back-btn" (click)="panelClose.emit()" (keydown.enter)="panelClose.emit()" (keydown.space)="$event.preventDefault(); panelClose.emit()" tabindex="0">{{ 'go_back' | translate }}</button>
  </div>
</div>